
export { FocusDirective as default };

const FocusDirective = {
  mounted(el, binding, vnode, prevVnode) {
    if(!binding.value) return;

    setTimeout(() => {
      el.focus();
    }, 100);
  },
}
